import React, {PureComponent} from 'react'
import Box from '../../../../../core/components/box/Box'
import Heading from '../../../../../core/components/typography/heading/Heading'
import Text from '../../../../../core/components/typography/text/Text'
import GridContainer from '../../../../../core/components/gridcontainer/GridContainer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {UniLink} from '../../../../../core/components/unilink/index'
import {subjectToImage, subjectToImageLight} from '../../../../../core/less/SubjectToImage'
import SubjectToCSSName from '../../../../../core/less/SubjectToCSSName'

class RecentSubjectCard extends PureComponent {
  render() {
    const {topic} = this.props
    return (
      <Box
        shadow
        color='white'
        paddingY={4}
        paddingX={4}
        smPaddingX={6}
        marginBottom={4}
        borderWidth='2px'
        clickable
        shape='round'>
        <UniLink to={topic.slug}>
          <Box
            alignItems='center'
            justifyContent='between'
            display='flex'>
            <Box display='flex' alignItems='center'>
              <Box marginRight={4}>
                <img style={{width:'56px',height: '56px'}} src={subjectToImageLight[topic.id]} />
              </Box>
              <Heading size='md' fontWeight='medium' color={`${SubjectToCSSName[topic.id]}-nav`}>
                {topic.title}
              </Heading>
            </Box>
            <Box>
              <Text color={`${SubjectToCSSName[topic.id]}-nav`}>
                <FontAwesomeIcon icon={['fa', 'angle-right']} />
              </Text>
            </Box>
          </Box>
        </UniLink>
      </Box>
    )
  }
}

class RecentSubjects extends PureComponent {

  render() {
    const {recentSubjects} = this.props
    return (
      <Box
        display='flex' 
        direction='column'
        dangerouslySetInlineStyle={{__style:{
          position: 'sticky',
          top: '5rem'
        }}}>
        <Box marginBottom={4}>
          <Heading size='sm' fontWeight='book' color='lightGray'> Recent Subjects </Heading>
        </Box>
        {
          recentSubjects
            ? recentSubjects.map(t=>(
              <RecentSubjectCard key={t.id} topic={t} />
            ))
            : null
        }
      </Box>
    )
  }
}

export class MobileRecentSubjects extends React.PureComponent {
  render() {
    const {recentSubjects} = this.props
    return (
      <Box
        marginBottom={8}
        width='calc(100% + 2rem)'
        marginLeft={-4}>
        <GridContainer>
          <Box marginBottom={2}>
            <Heading size='md' color='midGray' fontWeight='medium'>Recent Subjects</Heading>
          </Box>
        </GridContainer>
        <div className='subject-bar__subjects'>
          <div className='subject-bar__subjects-container gridcontainer'>
            {
              recentSubjects
                ? recentSubjects.map((s, index) => (
                  <div
                    key={s.id}
                    className='subject-bar__subject'>
                    <UniLink
                      className={`subject-bar__subject-button subject-bar__subject-button--${SubjectToCSSName[s.id]}`}
                      to={s.slug}
                    >
                      <img className='subject-bar__subject-image' src={subjectToImage[s.id]} />
                    </UniLink>
                    <span className='subject-bar__subject-name'>{s.title}</span>
                  </div>
                ))
                : null
            }
          </div>
        </div>
      </Box>
    )
  }
}

export default RecentSubjects



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/journey/components/RecentSubjects.js